import { isNil } from 'es-toolkit';

export interface PccRoomAmenity {
	description: string;

	id: number;
}

export interface PccBedInfo {
	description: string;

	/**
	 * PointClickCare's unique identifier for a bed within a facility.
	 *
	 * The facility beds endpoint returns this as `id`, so `PccBed` and `PccRoom` normalize it to `bedId` on construction.
	 */
	bedId: number;

	/**
	 * Bed identifier as returned by the facility beds endpoint. Normalized into `bedId`.
	 */
	id?: number;

	isCompanionBed: boolean;

	isMedicaidCertified: boolean;

	isMedicareCertified: boolean;

	isOccupied: boolean;
}

function normalizedBeds(beds: PccBedInfo[] = []): PccBedInfo[] {
	return beds.map((bed) => isNil(bed.bedId) && !isNil(bed.id) ? { ...bed, bedId: bed.id } : bed);
}

export class PccFloor {
	orgUuid: string;

	facId: number;

	floorId: number;

	floorDesc: string;

	roomCount? = 0;

	constructor(partial?: Partial<PccFloor>) {
		Object.assign(this, partial);
	}
}

export class PccUnit {
	facId: number;

	orgUuid: string;

	unitDesc: string;

	unitId: number;

	roomCount? = 0;

	constructor(partial?: Partial<PccUnit>) {
		Object.assign(this, partial);
	}
}

export class PccRoom {
	pccRoomAmenity: PccRoomAmenity[];

	beds: PccBedInfo[] = [];

	facId: number;

	floorId: number;

	orgUuid: string;

	roomDesc: string;

	roomId: number;

	unitId: number;

	rounders?: string[] = [];

	floorDesc?: string;

	unitDesc?: string;

	rounderNames?: string;

	constructor(partial?: Partial<PccRoom>) {
		Object.assign(this, partial);
		this.beds = normalizedBeds(this.beds);
	}
}

export class PccBed {
	beds: PccBedInfo[];

	facId: number;

	orgUuid: string;

	roomId: number;

	constructor(partial?: Partial<PccBed>) {
		Object.assign(this, partial);
		this.beds = normalizedBeds(this.beds);
	}
}

export class PccFacilityLayout {
	floors: PccFloor[];

	units: PccUnit[];

	rooms: PccRoom[];

	beds: PccBed[];

	constructor(partial?: Partial<PccFacilityLayout>) {
		Object.assign(this, partial);
	}
}
